export const DISTRICTS = [
  {
    id: 'N09000001',
    name: 'Antrim and Newtownabbey',
  },
  {
    id: 'N09000011',
    name: 'Ards and North Down',
  },
  {
    id: 'N09000002',
    name: 'Armagh City, Banbridge and Craigavon',
  },
  {
    id: 'N09000003',
    name: 'Belfast',
  },
  {
    id: 'N09000004',
    name: 'Causeway Coast and Glens',
  },
  {
    id: 'N09000005',
    name: 'Derry City and Strabane',
  },
  {
    id: 'N09000006',
    name: 'Fermanagh and Omagh',
  },
  {
    id: 'N09000007',
    name: 'Lisburn and Castlereagh',
  },
  {
    id: 'N09000009',
    name: 'Mid Ulster',
  },
  {
    id: 'N09000008',
    name: 'Mid and East Antrim',
  },
  {
    id: 'N09000010',
    name: 'Newry, Mourne and Down',
  },
];

export const AREAS = [
  {
    id: 'N10000101',
    name: 'Airport',
    district: 'N09000001',
  },
  {
    id: 'N10000102',
    name: 'Antrim',
    district: 'N09000001',
  },
  {
    id: 'N10001101',
    name: 'Ards Peninsula',
    district: 'N09000011',
  },
  {
    id: 'N10000201',
    name: 'Armagh',
    district: 'N09000002',
  },
  {
    id: 'N10000501',
    name: 'Ballyarnett',
    district: 'N09000005',
  },
  {
    id: 'N10000103',
    name: 'Ballyclare',
    district: 'N09000001',
  },
  {
    id: 'N10000801',
    name: 'Ballymena',
    district: 'N09000008',
  },
  {
    id: 'N10000401',
    name: 'Ballymoney',
    district: 'N09000004',
  },
  {
    id: 'N10000301',
    name: 'Balmoral',
    district: 'N09000003',
  },
  {
    id: 'N10000202',
    name: 'Banbridge',
    district: 'N09000002',
  },
  {
    id: 'N10001102',
    name: 'Bangor Central',
    district: 'N09000011',
  },
  {
    id: 'N10001103',
    name: 'Bangor East and Donaghadee',
    district: 'N09000011',
  },
  {
    id: 'N10001104',
    name: 'Bangor West',
    district: 'N09000011',
  },
  {
    id: 'N10000402',
    name: 'Bann',
    district: 'N09000004',
  },
  {
    id: 'N10000802',
    name: 'Bannside',
    district: 'N09000008',
  },
  {
    id: 'N10000403',
    name: 'Benbradagh',
    district: 'N09000004',
  },
  {
    id: 'N10000302',
    name: 'Black Mountain',
    district: 'N09000003',
  },
  {
    id: 'N10000303',
    name: 'Botanic',
    district: 'N09000003',
  },
  {
    id: 'N10000803',
    name: 'Braid',
    district: 'N09000008',
  },
  {
    id: 'N10000901',
    name: 'Carntogher',
    district: 'N09000009',
  },
  {
    id: 'N10000804',
    name: 'Carrick Castle',
    district: 'N09000008',
  },
  {
    id: 'N10000304',
    name: 'Castle',
    district: 'N09000003',
  },
  {
    id: 'N10000701',
    name: 'Castlereagh East',
    district: 'N09000007',
  },
  {
    id: 'N10000702',
    name: 'Castlereagh South',
    district: 'N09000007',
  },
  {
    id: 'N10000404',
    name: 'Causeway',
    district: 'N09000004',
  },
  {
    id: 'N10000902',
    name: 'Clogher Valley',
    district: 'N09000009',
  },
  {
    id: 'N10000805',
    name: 'Coast Road',
    district: 'N09000008',
  },
  {
    id: 'N10000405',
    name: 'Coleraine',
    district: 'N09000004',
  },
  {
    id: 'N10000305',
    name: 'Collin',
    district: 'N09000003',
  },
  {
    id: 'N10001105',
    name: 'Comber',
    district: 'N09000011',
  },
  {
    id: 'N10000903',
    name: 'Cookstown',
    district: 'N09000009',
  },
  {
    id: 'N10000306',
    name: 'Court',
    district: 'N09000003',
  },
  {
    id: 'N10000203',
    name: 'Craigavon',
    district: 'N09000002',
  },
  {
    id: 'N10001001',
    name: 'Crotlieve',
    district: 'N09000010',
  },
  {
    id: 'N10000204',
    name: 'Cusher',
    district: 'N09000002',
  },
  {
    id: 'N10000502',
    name: 'Derg',
    district: 'N09000005',
  },
  {
    id: 'N10001002',
    name: 'Downpatrick',
    district: 'N09000010',
  },
  {
    id: 'N10000703',
    name: 'Downshire East',
    district: 'N09000007',
  },
  {
    id: 'N10000704',
    name: 'Downshire West',
    district: 'N09000007',
  },
  {
    id: 'N10000904',
    name: 'Dungannon',
    district: 'N09000009',
  },
  {
    id: 'N10000104',
    name: 'Dunsilly',
    district: 'N09000001',
  },
  {
    id: 'N10000601',
    name: 'Enniskillen',
    district: 'N09000006',
  },
  {
    id: 'N10000602',
    name: 'Erne East',
    district: 'N09000006',
  },
  {
    id: 'N10000603',
    name: 'Erne North',
    district: 'N09000006',
  },
  {
    id: 'N10000604',
    name: 'Erne West',
    district: 'N09000006',
  },
  {
    id: 'N10000503',
    name: 'Faughan',
    district: 'N09000005',
  },
  {
    id: 'N10000504',
    name: 'Foyleside',
    district: 'N09000005',
  },
  {
    id: 'N10000105',
    name: 'Glengormley Urban',
    district: 'N09000001',
  },
  {
    id: 'N10001106',
    name: 'Holywood and Clandeboye',
    district: 'N09000011',
  },
  {
    id: 'N10000705',
    name: 'Killultagh',
    district: 'N09000007',
  },
  {
    id: 'N10000806',
    name: 'Knockagh',
    district: 'N09000008',
  },
  {
    id: 'N10000205',
    name: 'Lagan River',
    district: 'N09000002',
  },
  {
    id: 'N10000807',
    name: 'Larne Lough',
    district: 'N09000008',
  },
  {
    id: 'N10000406',
    name: 'Limavady',
    district: 'N09000004',
  },
  {
    id: 'N10000706',
    name: 'Lisburn North',
    district: 'N09000007',
  },
  {
    id: 'N10000707',
    name: 'Lisburn South',
    district: 'N09000007',
  },
  {
    id: 'N10000307',
    name: 'Lisnasharragh',
    district: 'N09000003',
  },
  {
    id: 'N10000206',
    name: 'Lurgan',
    district: 'N09000002',
  },
  {
    id: 'N10000106',
    name: 'Macedon',
    district: 'N09000001',
  },
  {
    id: 'N10000905',
    name: 'Magherafelt',
    district: 'N09000009',
  },
  {
    id: 'N10000605',
    name: 'Mid Tyrone',
    district: 'N09000006',
  },
  {
    id: 'N10000906',
    name: 'Moyola',
    district: 'N09000009',
  },
  {
    id: 'N10001003',
    name: 'Newry',
    district: 'N09000010',
  },
  {
    id: 'N10001107',
    name: 'Newtownards',
    district: 'N09000011',
  },
  {
    id: 'N10000308',
    name: 'Oldpark',
    district: 'N09000003',
  },
  {
    id: 'N10000606',
    name: 'Omagh',
    district: 'N09000006',
  },
  {
    id: 'N10000309',
    name: 'Ormiston',
    district: 'N09000003',
  },
  {
    id: 'N10000207',
    name: 'Portadown',
    district: 'N09000002',
  },
  {
    id: 'N10001004',
    name: 'Rowallane',
    district: 'N09000010',
  },
  {
    id: 'N10001005',
    name: 'Slieve Croob',
    district: 'N09000010',
  },
  {
    id: 'N10001006',
    name: 'Slieve Gullion',
    district: 'N09000010',
  },
  {
    id: 'N10000505',
    name: 'Sperrin',
    district: 'N09000005',
  },
  {
    id: 'N10000407',
    name: 'The Glens',
    district: 'N09000004',
  },
  {
    id: 'N10000506',
    name: 'The Moor',
    district: 'N09000005',
  },
  {
    id: 'N10001007',
    name: 'The Mournes',
    district: 'N09000010',
  },
  {
    id: 'N10000107',
    name: 'Three Mile Water',
    district: 'N09000001',
  },
  {
    id: 'N10000310',
    name: 'Titanic',
    district: 'N09000003',
  },
  {
    id: 'N10000907',
    name: 'Torrent',
    district: 'N09000009',
  },
  {
    id: 'N10000507',
    name: 'Waterside',
    district: 'N09000005',
  },
  {
    id: 'N10000607',
    name: 'West Tyrone',
    district: 'N09000006',
  },
];
